import React from 'react';
import JsonView from './JsonView';

class HostInfoJson extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    let hostInfo = this.props.hostInfo || {};

    return (
      <div style={{ background: 'rgb(255, 255, 250)', padding: '30px', margin: '0' }}>
        <JsonView
          title={'hostInfo'}
          data={hostInfo}
          hideRoot={false}
          shouldExpandNode={(levels, obj, level) => level <= 1}
          collectionLimit={150}
          raw={true}
        />
      </div>
    );
  }
}

export default HostInfoJson;



// WEBPACK FOOTER //
// ./src/components/HostInfoJson.js